import React from 'react';

export default class Page3 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt thought">
                                    <div className="innerpadding">

                                        <div className="ilead-contentarea">

                                            <div className="circle_title"><img
                                                src={require('@images/greendot.jpg')}
                                                alt=""/>INCREASING DISCRETIONARY EFFORT
                                            </div>

                                            <p>There are three requirements for encouraging DE in the workplace,
                                                concerning managerial
                                                activities, organisational environment and diversity issues. The
                                                way these are related is
                                                demonstrated like this: </p>

                                            <p className="para-first-pad" align="center"><img
                                                src={require('@images/increasing-diversity-effort.png')}/>
                                            </p>

                                            <p className="para-first-pad">Here are some things you need to do
                                                encourage DE in your workplace. You may already do some
                                                of them, but you could start thinking about those you hadn't
                                                considered, until now: </p>
                                            <div className="border_subtitle">Manage behaviours:</div>
                                            <ul className="greenbullet-list">
                                                <li>Openly recognise, praise and value any DE behaviour your
                                                    team shows.
                                                </li>
                                                <li>Give positive feedback to your team.</li>
                                                <li>Show interest in individual team members and their work
                                                    (even before seeing any
                                                    evidence of DE).
                                                </li>
                                                <li>Employees will demonstrate DE if it raises their profile
                                                    with others. As well as personally
                                                    recognising someone's effort, tell other managers about it,
                                                    if appropriate, and ask them to
                                                    acknowledge the individual, too.
                                                </li>
                                                <li>Talk about or demonstrate how instances of individual DE
                                                    have contributed to team or
                                                    organisational successes. This helps the individual
                                                    concerned and the rest of the team
                                                    understand its overall impact - and can even channel
                                                    competitiveness more constructively,
                                                    by demonstrating how everyone benefits.
                                                </li>

                                            </ul>


                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page2')}
                                                    className="button-next-previous-done thought">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page4')}
                                                    className="button-next-previous-done thought">Next &gt;&gt;</div>
                                            </div>


                                        </div>

                                    </div>


                                </div>


                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}